export const Footer = ({ t, lang, setLang }) => {
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="bg-[#183321] text-[#FDFDF9] py-20 md:py-28"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          <div className="md:col-span-6">
            <div className="flex items-baseline gap-2 mb-6">
              <span className="font-serif text-3xl md:text-4xl font-semibold tracking-wide uppercase">
                Josengineer
              </span>
              <span className="font-serif text-3xl md:text-4xl font-medium italic text-[#C26D5C] uppercase tracking-wider">
                Corp
              </span>
              <span className="ml-1 w-2 h-2 rounded-full bg-[#C26D5C]" />
            </div>
            <p className="font-serif text-xl md:text-2xl text-[#FDFDF9]/80 max-w-md leading-snug">
              {t.footer.tagline}
            </p>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.25em] text-[#FDFDF9]/60 font-semibold mb-5">
              {t.contact.details_title}
            </div>
            <div className="space-y-2 text-sm text-[#FDFDF9]/80">
              <div>16804 SW 109 CT</div>
              <div>Miami, FL 33157</div>
              <div className="pt-2">
                <a
                  href="tel:+17865652545"
                  className="hover:text-[#C26D5C] transition-colors"
                >
                  (786) 565-2545
                </a>
              </div>
              <div>
                <a
                  href="mailto:jsalas@josengineer.com"
                  className="hover:text-[#C26D5C] transition-colors"
                >
                  jsalas@josengineer.com
                </a>
              </div>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.25em] text-[#FDFDF9]/60 font-semibold mb-5">
              Language
            </div>
            <div className="flex items-center gap-2 text-sm">
              <button
                data-testid="footer-lang-en"
                onClick={() => setLang("en")}
                className={`px-3 py-1.5 rounded-sm transition-colors ${
                  lang === "en"
                    ? "bg-[#FDFDF9] text-[#183321]"
                    : "text-[#FDFDF9]/60 hover:text-[#FDFDF9]"
                }`}
              >
                English
              </button>
              <button
                data-testid="footer-lang-es"
                onClick={() => setLang("es")}
                className={`px-3 py-1.5 rounded-sm transition-colors ${
                  lang === "es"
                    ? "bg-[#FDFDF9] text-[#183321]"
                    : "text-[#FDFDF9]/60 hover:text-[#FDFDF9]"
                }`}
              >
                Español
              </button>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#FDFDF9]/15 flex flex-col md:flex-row justify-between gap-4 text-xs text-[#FDFDF9]/50">
          <div>
            © {year} josengineer. {t.footer.rights}
          </div>
          <div className="flex items-center gap-5">
            <a
              data-testid="footer-admin-link"
              href="/admin/login"
              className="hover:text-[#C26D5C] transition-colors uppercase tracking-widest"
            >
              Admin
            </a>
            <span className="text-[#FDFDF9]/30">·</span>
            <span>{t.footer.built}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};
